import { render, staticRenderFns } from "./BsFarmModule06.vue?vue&type=template&id=5d5e4095&scoped=true"
import script from "./BsFarmModule06.vue?vue&type=script&lang=js"
export * from "./BsFarmModule06.vue?vue&type=script&lang=js"
import style0 from "./BsFarmModule06.vue?vue&type=style&index=0&id=5d5e4095&prod&lang=scss&scoped=true"
import style1 from "./BsFarmModule06.vue?vue&type=style&index=1&id=5d5e4095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e4095",
  null
  
)

export default component.exports